import {apiPost} from './api';

export default class ServicioRecibos {
  static reporteRecibos(){
      return apiPost('/recibos/reporte','recibos');
  } 
  
}